import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import {useRouter} from 'next/router';
import Link from './Link';

import {FacebookButton, GoogleButton, LinkedInButton} from './SocialButton';
import Button from './Button';
import {useAppContext, useAnalytics} from '../hooks';
import {Close} from './Modal';

const SignupModal = ({
  isOpen, source, onClose, dismissible = false,
}) => {
  const {asPath: pathname} = useRouter();
  const {currentUser} = useAppContext();
  const {tracker} = useAnalytics();

  const sourceTypes = {
    lesson: {
      header: 'Create a free account to continue learning',
      subHeader: 'Sign up only takes a few seconds',
      onClick: tracker.lessonClickSignupWall,
    },
    course: {
      header: 'Create a free account to continue learning',
      subHeader: 'Sign up only takes a few seconds',
      onClick: tracker.courseClickSignupWall,
    },
    guides: {
      header: 'Create a free account to continue learning',
      subHeader: 'Sign up only takes a few seconds',
      onClick: tracker.guidesClickSignupWall,
    },
    socrates: {
      header: 'Create a free account to start practicing',
      subHeader: 'Get free, unlimited access to our interview question database',
      cta: 'Create a free account',
      ctaURL: '/signup',
      onClick: tracker.questionClickSignupWall,
    },
    duet: {
      header: 'Create an account to start practicing',
      subHeader: 'Join mock interviews with peers from top-tier tech companies',
      cta: 'Create a free account',
      ctaURL: '/signup',
      onClick: tracker.duetClickSignupWall,
    },
  };

  const {
    header,
    subHeader,
    ctaURL,
    cta,
    onClick,
  } = sourceTypes[source];

  return (
    <Modal
      overlayClassName="SignupModal__overlay"
      className="SignupModal"
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={dismissible}
      shouldCloseOnEsc={dismissible}
    >
      <div className="p-10 w-full max-w-2xl mx-auto text-center">
        {dismissible && <Close onClick={onClose} />}
        <h2 className="mb-2 text-2xl text-gray-900 font-bold leading-none">{header}</h2>
        <h3 className="text-sm font-medium text-gray-400">{subHeader}</h3>
        {currentUser ? (
          <div className="mb-6 flex flex-col max-w-sm mx-auto justify-center gap-2">
            <Button href={ctaURL}>{cta}</Button>
          </div>
        ) : (
          <>
            <div className="my-6 flex flex-col max-w-sm mx-auto justify-center gap-2">
              <GoogleButton
                returnPath={pathname}
                onClick={() => onClick({type: 'google'})}
              >
                Continue with Google
              </GoogleButton>
              <FacebookButton
                returnPath={pathname}
                onClick={() => onClick({type: 'facebook'})}
              >
                Continue with Facebook
              </FacebookButton>
              <LinkedInButton
                returnPath={pathname}
                onClick={() => onClick({type: 'linkedin'})}
              >
                Continue with LinkedIn
              </LinkedInButton>
            </div>
            <div className="text-gray-700 font-medium">
              Already use Exponent?&nbsp;
              <Link className="text-indigo font-semibold" href={`/login?returnPath=${pathname}`}>
                Sign in here
              </Link>
              .
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

SignupModal.propTypes = {
  source: PropTypes.oneOf(['course', 'lesson', 'socrates', 'duet', 'guides']).isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default SignupModal;
